import { LineChart, Coins, Boxes, Network } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import TvxCoin from "./TvxCoin";

const PILLARS = [
    {
        n: "01",
        t: "Trade",
        d: "Digital asset markets and trading.",
        icon: LineChart,
        tid: "ecosystem-pillar-trade",
    },
    {
        n: "02",
        t: "Earn",
        d: "Future opportunities across the TAVONX ecosystem.",
        icon: Coins,
        tid: "ecosystem-pillar-earn",
    },
    {
        n: "03",
        t: "TNX",
        d: "The TAVONX Utility Token powering ecosystem participation.",
        icon: Boxes,
        tid: "ecosystem-pillar-tvx",
    },
    {
        n: "04",
        t: "Ecosystem",
        d: "A growing network of products, services and digital experiences.",
        icon: Network,
        tid: "ecosystem-pillar-architecture",
    },
];

export default function Ecosystem() {
    return (
        <section id="ecosystem" data-testid="ecosystem-section" className="relative overflow-hidden bg-void py-24 lg:py-32">
            <div className="pointer-events-none absolute right-[-15%] top-[20%] h-[60vh] w-[50vw] rounded-full bg-[radial-gradient(circle,rgba(37,99,235,0.07),transparent_70%)]" />

            <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
                <div className="grid items-center gap-16 lg:grid-cols-2">
                    <div>
                        <Reveal>
                            <Eyebrow>Tavonx Ecosystem</Eyebrow>
                        </Reveal>
                        <Reveal delay={0.08}>
                            <h2 className="font-grotesk text-2xl font-bold uppercase leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl">
                                More than <span className="text-grad-blue">an exchange.</span>
                            </h2>
                        </Reveal>
                        <Reveal delay={0.14}>
                            <p className="mt-5 max-w-md text-base leading-relaxed text-slate-400">
                                One ecosystem. Multiple ways to participate in the digital economy.
                            </p>
                        </Reveal>

                        <div className="mt-12">
                            {PILLARS.map((p, i) => (
                                <Reveal key={p.n} delay={0.1 + i * 0.07}>
                                    <div
                                        data-testid={p.tid}
                                        className="group flex items-start gap-5 border-b border-white/[0.06] py-6 transition-all duration-500 first:border-t hover:bg-white/[0.02] hover:pl-3"
                                    >
                                        <span className="mt-1 font-mono text-xs tracking-[0.3em] text-cyber/70">
                                            {p.n}
                                        </span>
                                        <p.icon
                                            className="mt-0.5 h-5 w-5 shrink-0 text-slate-500 transition-colors duration-500 group-hover:text-cyber"
                                            strokeWidth={1.5}
                                        />
                                        <div>
                                            <h3 className="font-grotesk text-base font-semibold uppercase tracking-[0.18em] text-white transition-colors duration-500 group-hover:text-cyber">
                                                {p.t}
                                            </h3>
                                            <p className="mt-1.5 text-sm leading-relaxed text-slate-400">
                                                {p.d}
                                            </p>
                                        </div>
                                    </div>
                                </Reveal>
                            ))}
                        </div>
                    </div>

                    <Reveal delay={0.15} className="flex justify-center">
                        <TvxCoin size={320} testId="ecosystem-tvx-coin-visual" />
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
